
const NOTIFY_DEBOUNCE_TIME = 2000;


const messageHistory = {
    middle: {
        message: '',
        timestamp: 0
    },
    right: {
        message: '',
        timestamp: 0
    },
    define: {
        message: '',
        timestamp: 0
    }
};


let isScrolling = false;
const handleScroll = () => {
    if (!isScrolling) {
        window.requestAnimationFrame(() => {
            const messages = document.querySelectorAll('.mobile-message');
            const scrollY = window.scrollY || window.pageYOffset;
            messages.forEach(msg => {
                msg.style.top = `${scrollY + 20}px`;
            });
            isScrolling = false;
        });
    }
    isScrolling = true;
};


function middleMsg(type, message, duration = 1400) {
    const now = Date.now();
    if (now - messageHistory.middle.timestamp < NOTIFY_DEBOUNCE_TIME &&
        messageHistory.middle.message === message) return;

    messageHistory.middle = {
        message,
        timestamp: now
    };
    this.$message({
        type,
        message,
        duration
    });
}

function rightMsg(title, type, message, offset = 100, duration = 1400) {
    const now = Date.now();
    if (now - messageHistory.right.timestamp < NOTIFY_DEBOUNCE_TIME &&
        messageHistory.right.message === message) return;

    messageHistory.right = {
        message,
        timestamp: now
    };
    this.$notify({
        title,
        type,
        message,
        offset,
        duration
    });
}

function defineMessage(type, message, title = "", duration = 2000) {
    const now = Date.now();
    if (now - messageHistory.define.timestamp < NOTIFY_DEBOUNCE_TIME &&
        messageHistory.define.message === message) return;

    messageHistory.define = {
        message,
        timestamp: now
    };

    if (window.innerWidth < 768) {
        const scrollY = window.scrollY || window.pageYOffset;
     

        this.$message({
            type,
            message,
            duration,
            offset: scrollY
        });
    } else {
        this.$notify({
            title,
            type,
            message,
            offset: 100,
            duration: duration
        });
    }
}

const messagePlugin = {
    install(Vue) {
       
        if (window.innerWidth < 768 && !window._mobileMessageScrollListener) {
            window.addEventListener('scroll', handleScroll);
            window._mobileMessageScrollListener = true;
        }

        Vue.prototype.$middleMsg = middleMsg;
        Vue.prototype.$rightMsg = rightMsg;
        Vue.prototype.$defineMessage = defineMessage;
    }
};


export {
    middleMsg,
    rightMsg,
    defineMessage,
};
export default messagePlugin;    